import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@mui/material";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdatedOutlined";
import { useDispatch } from "react-redux";
import { activateDisruption } from "../../../store/actions/smrt/disruptionAction";
import { useTranslation } from "react-i18next";
import parser from "html-react-parser";

const ActivateDisruption = ({ announcement }) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(activateDisruption(announcement));

    handleClose();
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        startIcon={<BrowserUpdatedIcon fontSize="small" />}
        variant="outlined"
      >
        <strong>{t("link.activateBtn")}</strong>
      </Button>

      <Dialog open={open} onClick={handleClose} maxWidth="sm">
        <Box component="form" onSubmit={handleSubmit}>
          <DialogTitle>{t("link.disruptConfirmTitle")}</DialogTitle>

          <DialogContent>
            <DialogContentText>
              {parser(t("link.activateConfirmText"))}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} fullWidth variant="outlined">
              {tCommon("cancelBtn")}
            </Button>

            <Button type="submit" fullWidth variant="contained">
              {t("link.activateConfirmBtn")}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default ActivateDisruption;
